import { Component, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';

import { ApplicationConfig } from '../../config/application.config';
import { ApplicationActions } from '../../../shared/store/application/application.actions';
import { LanguageVersion } from '../../../shared/model/local/config/language-version';
import { ApplicationStateModel } from '../../../shared/store/application/application.state';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';

// The header offers no "Sign up": every account card already leads there
// (sign-in under its button, the other cards back to sign-in)
@Component({
  selector: 'app-preliminary-layout',
  standalone: true,
  imports: [RouterOutlet, LanguageSwitcherComponent],
  templateUrl: './preliminary-layout.component.html',
  styleUrl: './preliminary-layout.component.scss',
})
export class PreliminaryLayoutComponent {
  private store = inject(Store);

  websiteUrl: string = ApplicationConfig.websiteUrl;

  language$ = this.store.select(
    (state: { application: ApplicationStateModel }) =>
      state.application.language
  );

  languageVersions: LanguageVersion[] = Object.values(
    LanguageVersion
  ) as LanguageVersion[];

  goToWebsite(): void {
    window.location.href = this.websiteUrl;
  }

  changeLanguage(lang: LanguageVersion): void {
    this.store.dispatch(new ApplicationActions.ChangeLanguage(lang));
  }
}
